import Vue from 'vue';
import Router from 'vue-router';
import { LOGIN_REDIRECT_URL } from '@/constants';
import { pinia } from '@/pinia';
import { useUserStore } from '@/store/user';
import { getAccessRedirect } from '@/utils/access';

Vue.use(Router);

const router = new Router({
    base:   import.meta.env.BASE_URL,
    mode:   'history',
    routes: [

        {

            children: [
                // =============================================================================
                // Theme Routes
                // =============================================================================
                {
                    component: () => import('./views/Home/Index.vue'),
                    meta:      {
                        rule: 'complex',
                    },
                    name: 'statistics',
                    path: '/',
                },
                {
                    component: () => import('./views/leads/Index.vue'),
                    meta:      {
                        rule: 'complex',
                    },
                    name: 'leads',
                    path: '/leads',
                },
                {
                    beforeEnter: (to, from, next) => {
                        if (useUserStore(pinia).isAuthorized) next('/');
                        else window.location.href = LOGIN_REDIRECT_URL;
                    },
                    name: 'auth',
                    path: '/auth',
                },
                {
                    component: () => import('@/views/errors/Error404.vue'),
                    name:      'error-404',
                    path:      '/error-404',
                },
                {
                    component: () => import('@/views/errors/Error403.vue'),
                    name:      'error-403',
                    path:      '/error-403',
                },
            ],

            component: () => import('./layouts/Main.vue'),
            // =============================================================================
            // MAIN LAYOUT ROUTES
            // =============================================================================
            path:      '',
        },
        {
            component: () => import('./views/report/Index.vue'),
            meta:      {
                rule: 'complex',
            },
            name:  'report',
            path:  '/report',
            props: true,
        },
        // Redirect to 404 page, if no match found
        {
            path:     '*',
            redirect: '/error-404',
        },
    ],
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
});

router.beforeEach(async (to, from, next) => {
    const userStore = useUserStore(pinia);

    if (!userStore.isAuthorized) {
        try { await userStore.getSession(); } catch (e) { /* no-op */ }
    }

    const redirect = getAccessRedirect(to, from, {
        isAuthorized: userStore.isAuthorized,
        isPro:        userStore.isPro,
        userRole:     userStore.user.userRole,
    });

    // next — ровно один раз: Vue Router 4 не допускает повторного вызова
    if (redirect) next(redirect);
    else next();
});

export default router;
